<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-row>
            <div style="position: fixed; z-index: 1;  background-color: white; width: 100%; top:55px;">
            <v-breadcrumbs :items="items" large style=" font-weight: 600; letter-spacing: 1px; ">

            </v-breadcrumbs>
            </div>
        </v-row><br><br>
        <br />
        <v-card class="card">
            <v-card-title class="heading justify-center">
                <span>Book Format</span>
            </v-card-title>
            <div v-if="init_loading">
          <v-skeleton-loader v-bind="attrs" type="three-line,  article"></v-skeleton-loader>
        </div>
        <div v-else>
            <v-card-text>
                <div class="add-section">
                    <div style="text-align: center;">
                        <v-col>
                            <v-form ref="form">
                                <label class="add-text">Add New Book Format</label><span style="color: red;"> *</span>
                                <v-text-field class="text" v-model="bookFormat" outlined dense :rules="[rules.required]"
                                    clearable required></v-text-field>
                                <label class="add-text">Display Order</label><span style="color: red;"> *</span>
                                <v-text-field class="text" type="number" v-model="displayorder" outlined
                                    dense></v-text-field>
                                <label class="add-text"> Short Name</label>
                                <v-text-field class="text" v-model="shortname" outlined dense></v-text-field>
                                <v-btn color="success" @click="addBookFormat">Add</v-btn>
                            </v-form>
                        </v-col>
                    </div>
                </div>

                <template>
                    <div class="text-center">
                        <v-dialog v-model="dialog" width="500">
                            <v-card>
                                <v-card-title class="grey lighten-2">
                                    Edit Book Format
                                </v-card-title>

                                <v-card-text style="padding-bottom: 0px;">
                                    <label class="add-text">Book Format</label><span style="color: red;"> *</span>
                                    <v-text-field class="text" v-model="bookFormatName" outlined dense
                                        :rules="[rules.required]" clearable required></v-text-field>
                                    <label class="add-text"> Display Order</label><span style="color: red;"> *</span>
                                    <v-text-field class="text" type="number" v-model="displayorder" outlined :min="0"
                                        dense></v-text-field>
                                    <label class="add-text"> Short Name</label>
                                    <v-text-field class="text" v-model="shortname" outlined dense></v-text-field>
                                </v-card-text>

                                <!-- <v-divider></v-divider> -->

                                <div class="text-center">
                                    <v-spacer></v-spacer>
                                    <v-btn class="m-3" color="error" @click="dialog = false">
                                        Close
                                    </v-btn>
                                    <v-btn class="m-3" color="success" @click="saveEdit()">Update</v-btn>
                                </div>
                            </v-card>
                        </v-dialog>
                    </div>
                </template>
                <div v-if="loader">
          <v-skeleton-loader v-bind="attrs" type="three-line,  article"></v-skeleton-loader>
        </div>
        <div v-else>
                <template v-if="bookFormat_list != null">
                    <v-data-table :headers="headers" :items="bookFormat_list" :search="search" class="elevation-1 nowrap">
                        <template v-slot:top>
                            <v-toolbar flat color="white">
                                <v-spacer></v-spacer>
                                <v-text-field v-model="search" append-icon="mdi-magnify" label="Search in table" single-line
                                    hide-details></v-text-field>
                            </v-toolbar>
                        </template>
                        <template v-slot:item.edit="{ item }">
                            <!-- <v-icon v-if="item.edit==true" color="success" class="mr-2">mdi-check-circle-outline</v-icon> -->
                            <v-icon v-if="item" class="mr-2" @click="updateBookFormat(item)">mdi mdi-pencil-box</v-icon>
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <!-- <v-btn :loading="edit_btn_load" @click="editItem(item)" class="link" color="info"> <v-icon title="Activate/Deactivate the User Type">mdi-recycle</v-icon></v-btn> -->
                            <v-switch v-model="item.bookFormatIsactive" @change="editItem(item)"></v-switch>
                        </template>
                        <template v-slot:item.delete="{ item }">
                            <v-icon v-if="item" class="mr-2" @click="deleteBookFormat(item)"> mdi mdi-delete</v-icon>
                        </template>
                    </v-data-table>
                </template>
                </div>
            </v-card-text>
            </div>
        </v-card>
        <!-- <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay> -->
    </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data: () => ({
        init_loading: false,
        loader: false,
        snackbar_msg: "",
        snackbar: false,
        color: "",
        org: null,
        dialog: false,
        search: "",
        bookFormat: null,
        bookFormatId: null,
        bookFormatName: null,
        userType: null,
        edit_btn_load: false,
        items: [
            {
                text: 'Dashboard',
                disabled: false,
                href: '/home',
            },
            {
                text: localStorage.getItem("jhhjbyj"),
                disabled: false,
                href: '/sublink',
            },
            {
                text: 'Admin Master',
                disabled: false,
                href: '/admin-master',
            },
            {
                text: 'Book Format',
                disabled: true,
                href: '',
            },
        ],
        rules: {
            required: (value) => !!value || "Required.",
        },
        bookFormat_list: null,
        headers: [
            { text: "Sr no", value: "srno" },
            { text: "Name", value: "bookFormat" },
            { text: "Short Name", value: "shortname" },
            { text: "Edit", value: "edit" },
            { text: "Toggle", value: "actions", sortable: false },
            { text: "Delete", value: "delete" },
        ],
    }),
    watch: {},
    methods: {
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        editItem(item) {
            console.log(item);
            axios
                .post("/admin/bookFormatIsactive", item)
                .then(() => {
                    // this.sec_mode_list = res.data.user_list;
                    this.showSnackbar("#4CAF50", "Book format updated successfully...");
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    console.log(error);
                })
                .finally(() => {
                    this.edit_btn_load = false;
                    axios;
                });
        },

        updateBookFormat(item) {
            this.dialog = true;
            this.bookFormatName = item.bookFormat;
            this.bookFormatId = item.bookFormatId;
            this.displayorder = item.displayorder;
            this.shortname = item.shortname;
        },

        saveEdit(item) {
            if (this.bookFormatName) {
                this.bookFormatName = this.bookFormatName.trim()
            }
            if (this.bookFormatName == null || this.bookFormatName == "") {
                this.showSnackbar("#b71c1c", "Please Enter Book Format");
                return;
            }
            if (this.displayorder == null || this.displayorder == "") {
                this.showSnackbar("#b71c1c", "Please Enter Display Order");
                return;
            }
            const data = {
                bookFormatName: this.bookFormatName,
                bookFormatId: this.bookFormatId,
                displayorder: this.displayorder,
                shortname: this.shortname,
            };
            if (this.bookFormatName) {
                this.loader =true;
                axios
                    .post("/admin/editBookFormat", data)
                    .then((res) => {
                        if (res.data.msg == "success") {
                            this.loader = false;
                            this.sec_mode_list = res.data.user_list;
                            this.showSnackbar("#4CAF50", "Book format updated successfully...");
                            this.onload();
                            this.dialog = false;
                        } else {
                            this.loader = false;
                            this.showSnackbar("#b71c1c", res.data.msg);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        console.log(error);
                    })
                    .finally(() => {
                        this.edit_btn_load = false;
                        // this.editUserType = null;
                        axios;
                    });
            } else {
                this.showSnackbar("#b71c1c", "Please enter Book format");
            }
        },
        deleteBookFormat(item) {
            const data = {
                bookFormatId: item.bookFormatId,
            };
            axios
                .post("/admin/deleteBookFormat", data)
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.showSnackbar("#4CAF50", "Book format Deleted Successfully  !!");
                        this.onload();
                    } else if (res.data.msg == "exp") {
                        this.showSnackbar("#b71c1c", "Can not be Deleted!!!");
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    window.console.log(error);
                });
        },
        onload() {
            this.init_loading = true
            axios
                .post("/admin/getBookFormat")
                .then((res) => {
                    this.org = res.data.org;
                    this.bookFormat_list = res.data.bookFormat;
                    this.init_loading = false
                    //this.showSnackbar("#4CAF50","Success")
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    console.log(error);
                })
                .finally(() => {
                    this.init_loading = false
                });
        },

        addBookFormat() {
            if (this.bookFormat) {
                this.bookFormat = this.bookFormat.trim()
            }
             if (this.bookFormat == null || this.bookFormat == "") {
                this.showSnackbar("#b71c1c", "Please Enter Book Format");
                return;
            }
            if (this.displayorder == null || this.displayorder == "") {
                this.showSnackbar("#b71c1c", "Please Enter Display Order");
                return;
            }
            const data = {
                bookFormat_name: this.bookFormat,
                displayorder: this.displayorder,
                shortname: this.shortname,
            };

            if (this.bookFormat) {
                this.loader = true;
                axios
                    .post("/admin/addBookFormat", data)
                    .then((res) => {
                        this.org = res.data.org;
                        this.bookFormat_list = res.data.bookFormat_list;
                        if (res.data.msg == "success") {
                            this.loader = false;
                            this.showSnackbar("#4CAF50", "Book format added successfully...");
                            this.userType = null;
                            this.onload();
                            this.$refs.form.reset()
                        } else {
                            this.loader = false;
                            this.showSnackbar("#b71c1c", res.data.msg);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        console.log(error);
                    })
                    .finally(() => { });
            } else {
                this.showSnackbar("#b71c1c", "Please enter Book format");
                this.loader = false;
                this.$refs.form.validate()
            }
        },
    },
    mounted() {
        this.onload();
    },
};
</script>
<style scoped>
.heading {
    background-color: #3f51b5;
    padding: 0.3rem;
    color: white;
}

.v-icon {
    cursor: pointer;
}

.text>>>.v-input__slot {
    background: white !important;
    border-color: hsla(190, 99%, 30%, 1) !important;
}
</style>
